module.exports = __webpack_public_path__ + "img/about-m-slide-24.6e23a2da.jpg";